// 基准大小
const baseSize = 14;
// 设置 rem 函数
function setRem() {
 // 当前页面宽度相对于设计稿宽度（1920px）的缩放比例
 const scale = document.documentElement.clientWidth / 1920;
 // 设置根节点字体大小，最大放大比例为2倍
 document.documentElement.style.fontSize = `${(Math.min(scale, 2) * baseSize)-2}px`;
}
// 初始化
setRem();
// 监听窗口变化，实时调整
window.addEventListener('resize', setRem);